import React from 'react';

export const LogoScroll = () => {
  // Array of logo URLs (using placeholder images; replace with actual logo URLs)
  const logos = [
    '/img/logos/aws-partner-advanced.png',
    '/img/logos/oracle-partner.png',
    '/img/logos/forbes.png',
    '/img/logos/hp.jpeg',
    '/img/logos/microsoft-partner.png',
    '/img/logos/amcham.png',
    '/img/logos/ueh.png',
    '/img/logos/fpt.png',
    '/img/logos/bachkhoa.png',
    '/img/logos/complianceplus.png'
  ];

  // Duplicate logos to create seamless loop
  const doubledLogos = [...logos, ...logos];

  return (
    <div className="logo-scroll-container">
      <div className="logo-scroll">
        {doubledLogos.map((logo, index) => (
          <img key={index} src={logo} alt={`Logo ${index + 1}`} />
        ))}
      </div>
    </div>
  );
};

